const steps = ['SharePoint Access Key', 'Choose file', 'Manage meta info'];

export { steps };
